import React, { useState } from 'react'
import { 
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col
} from 'reactstrap'
import _ from 'lodash'
import NumberFormat from "react-number-format"

import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import CurrencySettings from 'utils/currencies'

const Update = ({
  showUpdateTreatment,
  selectedTreatment,
  onChangeTreatmentsHOC,
  onLoadTreatments,
  updateTreatment
}) => {

  const onChangeTreatmentData = ( key, val ) => {
    let tmp = _.cloneDeep( selectedTreatment )
    tmp[ key ] = val
    return onChangeTreatmentsHOC( 'selectedTreatment', tmp )
  }

  return (
    <Modal
      isOpen={ showUpdateTreatment }
      size={ 'md' }
      toggle={() => {
        onChangeTreatmentsHOC( 'showUpdateTreatment', false )
      }}>
      <ModalHeader toggle={() => onChangeTreatmentsHOC( 'showUpdateTreatment', false )}>Update treatment</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup>
            <Label>Name</Label>
            <Input 
              type="text"
              value={ selectedTreatment.name }
              onChange={ e => {
                onChangeTreatmentData( 'name', e.target.value )
              }} />
          </FormGroup>  
          <FormGroup>
            <Label>{`Amount - ${ CurrencySettings() }`}</Label>
            <NumberFormat
              className="form-control"
              value={ selectedTreatment.price }
              thousandSeparator={ "," }
              decimalSeparator={ "." }
              onValueChange={( values ) => {
                const { formattedValue, value } = values;
                onChangeTreatmentData( 'price', value )
              }}
              inputMode="numeric"
              displayType="input"
            />
          </FormGroup>  
        </Form>
        { onLoadTreatments && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary"
          onClick={() => {
            updateTreatment( selectedTreatment )
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default Update